import React, { useContext } from 'react';
import { Image, ImageFit, IRawStyle, useTheme } from '@fluentui/react';
import { SuiteHeaderContext } from '../SuiteHeaderProvider';
import { tenantBrandingStyles } from './TenantBranding.styles';
import { ITenantBrandingProps } from './TenantBranding.types';

export const TenantBranding: React.FC<ITenantBrandingProps> = props => {
  const context = useContext(SuiteHeaderContext);
  const { imageUrl } = props;
  const theme = useTheme();
  return (
    <Image
      src={imageUrl}
      alt={context.localizationMap['tenantBrandingImageAlt']}
      imageFit={ImageFit.contain}
      styles={{
        ...tenantBrandingStyles,
        root: {
          ...(tenantBrandingStyles.root as IRawStyle),
          maxHeight: theme.fonts.xLargePlus.fontSize,
          maxWidth: '8.125rem',
          height: '100%'
        }
      }}
    />
  );
};
